import { selector } from '@/lib/selectors';

const ui = (state) => state.ui;

const modalSelector = selector(ui, (x) => x.modal);
const approvalFlowSelector = selector(ui, (x) => x.approvalFlow);
const workspaceSelector = selector(ui, (x) => x.workspace);
const selectSelector = selector(ui, (x) => x.select);
const drawerSelector = selector(ui, (x) => x.drawer);
const extractedFieldsSelector = selector(ui, (x) => x.extractedFields);

export const isOpenModalDocumentHotkeysSelector = selector(modalSelector, (modal) => modal.isOpenDocumentHotkeysModal);

export const isOpenModalWorkspaceHotkeysSelector = selector(
  modalSelector,
  (modal) => modal.isOpenWorkspaceHotkeysModal,
);

export const isOpenAFPanelSelector = selector(approvalFlowSelector, (af) => af.isOpen);

export const uiApprovalStampPositionSelector = selector(approvalFlowSelector, (af) => af.stampPosition);

export const getUiWorkspaceIsActiveContextMenuSelector = selector(workspaceSelector, (ws) => ws.isActiveContextMenu);

export const isUiSelectOpenSelector = selector(selectSelector, (s) => s.isOpen);

export const isOpenUiDrawerSelector = selector(drawerSelector, (d) => d.isOpen);

export const isUiExtractedFieldsHighlightedSelector = selector(extractedFieldsSelector, (f) => f.isHighlighted);
